import { useCallback } from "react";
import { Util } from "@xt/xtbase";

import store from "store";

const { Big } = Util;

export interface PriceCurrencyConvertCbOptionProps {
  value?: number | string;
  coin?: string;
  targetCoin?: string;
  thousands?: boolean;
  unit?: boolean;
  reverse?: boolean;
  exchangeRate?: string;
}

const usePriceCurrencyConvertCb: () => (option: PriceCurrencyConvertCbOptionProps) => string = () => {
  const { name } = store.market;
  const { priceCurrencyConvert } = store.currency;
  const { convertCurrency } = store.balances;

  return useCallback(
    (option: PriceCurrencyConvertCbOptionProps) => {
      let { value, coin, targetCoin, thousands = true, unit = true, reverse, exchangeRate } = option;

      let result = "0";
      !value && (value = 0);
      !coin && (coin = name.split("_")[1] || "usdt");
      const referCoin = targetCoin || convertCurrency || "usd";

      if (exchangeRate) {
        result = Big(value).times(exchangeRate).toFixed();
      } else if (priceCurrencyConvert) {
        const doc = priceCurrencyConvert[coin];
        if (doc && doc[referCoin]) {
          result = reverse ? Big(value).div(doc[referCoin]).toFixed() : Big(value).times(doc[referCoin]).toFixed();
        }
      }

      const affix = unit ? " " + (reverse ? coin.toUpperCase() : referCoin.toUpperCase()) : "";

      if (["btc"].includes(referCoin)) {
        if (Big(result).minus(0.00000001).toNumber() >= 0 || Big(result).minus(0).toNumber() === 0) {
          return (thousands ? Big(result).toFixedCy(8) : Big(result).toFixed(8)) + affix;
        }
      } else if (referCoin === "krw") {
        if (Big(result).minus(1).toNumber() >= 0 || Big(result).minus(0).toNumber() === 0) {
          return (thousands ? Big(result).toFixedCy(0) : Big(result).toFixed(0)) + affix;
        }
      } else {
        const minus01 = Big(result).minus(0.01).toNumber();
        const minus0001 = Big(result).minus(0.0001).toNumber();
        const minus000001 = Big(result).minus(0.000001).toNumber();
        const minus00000001 = Big(result).minus(0.00000001).toNumber();
        const minus000000000001 = Big(result).minus(0.000000000001).toNumber();
        const minus00000000000001 = Big(result).minus(0.00000000000001).toNumber();
        const minus0000000000000001 = Big(result).minus(0.0000000000000001).toNumber();

        if (minus01 >= 0 || Big(result).minus(0).toNumber() === 0) {
          return (thousands ? Big(result).toFixedCy(2) : Big(result).toFixed(2)) + affix;
        }
        if (minus0001 >= 0 && minus01 < 0) {
          return (thousands ? Big(result).toFixedCy(4) : Big(result).toFixed(4)) + affix;
        }
        if (minus000001 >= 0 && minus0001 < 0) {
          return (thousands ? Big(result).toFixedCy(6) : Big(result).toFixed(6)) + affix;
        }
        if (minus00000001 >= 0 && minus000001 < 0) {
          return (thousands ? Big(result).toFixedCy(8) : Big(result).toFixed(8)) + affix;
        }
        if (minus000000000001 >= 0 && minus00000001 < 0) {
          return (thousands ? Big(result).toFixedCy(10) : Big(result).toFixed(10)) + affix;
        }
        if (minus00000000000001 >= 0 && minus000000000001 < 0) {
          return (thousands ? Big(result).toFixedCy(12) : Big(result).toFixed(12)) + affix;
        }
        if (minus0000000000000001 >= 0 && minus00000000000001 < 0) {
          return (thousands ? Big(result).toFixedCy(14) : Big(result).toFixed(14)) + affix;
        }
      }

      return (thousands ? Big(result).toFixedMaxCy(16) : Big(result).toFixedMax(16)) + affix;
    },
    [convertCurrency, name, priceCurrencyConvert]
  );
};

export default usePriceCurrencyConvertCb;
